import { Pipe, PipeTransform } from '@angular/core';
import { ProductName } from '../../graphql-client/graphql';

@Pipe({
  name: 'mark'
})
export class MarkPipe implements PipeTransform {
  transform(product: ProductName): string {
    if (product === ProductName.Prolia) {
      return `&reg;`;
    } else {
      return `&trade;`;
    }
  }
}
